import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlertServiceProvider } from "../../providers/alert-service/alert-service";
import { responseObj } from "./nest-model/nest-model";
import { Messages } from "../../helpers/messages";
import { TimeoutError } from "rxjs";

@Injectable()
export class NestResponsesProvider {

  constructor(
    private alertService: AlertServiceProvider,
  ) { }

  success(response: responseObj<any>, message?: string): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        if (message) {
          await this.alertService.createMola(message);
        }
        else {
          await this.alertService.createMola(response.message);
        }
        resolve(true)
      }
      catch (error) {
        await this.alertService.createMola(Messages.SUCCESSFULLY);
        resolve(true)
      }
    })
  }

  error(error): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        // const message = `Error with status code ${error.status} - ${error.error.message || error.statusText}`;
        const message = this.handleMsgError(error, true);
        await this.alertService.createMola(message);
        resolve(true);
      }
      catch (error) {
        await this.alertService.createMola(Messages.SERVER_ERROR);
        resolve(true);
      }
    })
  }

  handleMsgError(error: any, loopError: boolean = false) {
    let msg: string = Messages.SERVER_ERROR;
    console.log(error);

    try {
      try {
        msg = `${error.error.message || error.statusText} (Status Code ${error.status})`;
      } catch (error) { }

      if (error instanceof HttpErrorResponse || error.hasOwnProperty('error') || error.hasOwnProperty('message')) {
        if (error.hasOwnProperty('status') || (error.error && error.error.hasOwnProperty('customError'))) {
          if (error.status == 0) {
            msg = error.message ? error.message : 'Http failure';
          }
          else if (error.status >= 500) {
            console.log('error', error)
            if (error.error && error.error.error && error.error.error.message) {
              msg = error.error.error.message;
            }
          }
          else {
            if (error.error) {
              if (error.error.message) {
                msg = error.error.message;
                if (loopError && error.error.errors) {
                  if (error.error.errors.length > 0) {
                    let tempTeks = '';
                    for (let item of error.error.errors) {
                      tempTeks += `- ${item.messages}<br>`;
                    }
                    msg = tempTeks;
                  }
                }
              }
              else {
                if (error.message) {
                  msg = error.message
                }
                else {
                  msg = error.status + (error.error) ? ` ${error.error}` : ' Network Failure';
                }
              }
            }
            else {
              if (error.message) {
                msg = error.message;
              }
              else {
                msg = error.status + ' error network without messagge';
              }
            }
          }
        }
        else {
          if (error.message) {
            msg = error.message;
          }
          else {
            msg = error;
          }
        }
      } else if (error instanceof TimeoutError) {
        msg = error.message ? error.message : 'Timeout Error';
      } else if (typeof error === 'string') {
        msg = error;
      }
    } catch (error) {
      msg = Messages.SERVER_ERROR;
    }
    return msg;
  }

  handleErrorList(error) {
    // (err && err.status && err.status >= 500) ? [] : err.error.errors
    let result = [];

    if (error) {
      if (error.status) {
        if (error.status < 500) {
          if (error.error) {
            if (error.error.errors) {
              result = error.error.errors;
            }
          }
        }
      }
    }

    return result;
  }

}

export interface ResponseData<T> {
  data: T;
  message: string;
  // success: boolean;
}

export interface ResponseDataTransaction<T> {
  data: T;
  message: string;
  refNo: string;
  status: any;
}

export interface ResponsePaging<T> {
  page: number;
  limit: number;
  total: number;
  totalPage: number;
  data: T[];
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/nest-responses.ts